import { connect } from 'react-redux'
import SubcontractorSubOrders from './SubOrders'

import componentDidMount from './Handlers/componentDidMount'

const mapStateToProps = () => ({})

const actionCreators = {
  componentDidMount,
}

export default connect(mapStateToProps, actionCreators)(SubcontractorSubOrders)
